import { NgModule } from '@angular/core';
import { ToolsComponent } from './tools.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { NgPipesModule } from 'ngx-pipes';
/* Pagination module imported */
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxUploaderModule  } from 'ngx-uploader'; // file upload

import { TruncateModule } from '@yellowspot/ng-truncate';
import { SelectDropDownModule } from 'ngx-select-dropdown';

import { TranslateModule } from '@ngx-translate/core';

import { NgImageSliderModule } from 'ng-image-slider';

// import { ProjectFilterPipe } from '../../../../projects/projectmanagement/src/app/directive/Filters/ctl.projectlist.filter';
import { CtlPagination } from './directives/pagination/ctl-pagination.directive';
import { CtlWizardSteps } from './directives/WizardSteps/CtlWizardSteps.directive';
import { CtlLogoUpload } from './directives/UploadLogo/CtlLogoUpload';
import { CtlNewMediaFileUploadComponent } from './directives/UploadNewMediaFile/CtlNewMediaFileUpload.directive';
import { ModalformComponent } from './modalform/modalform.component';
import { CtlConfirmModalComponent } from './ctl-confirm-modal/ctl-confirm-modal.component';
import { CtlSuccessModalComponent } from './ctl-success-modal/ctl-success-modal.component';

import { CtlUserForm } from './forms/user/CtlUserForm';
import { CtlSchoolInfoDetail } from './forms/schooldetails/CtlSchoolInfoDetail.directive';
import { CtlPartnerForm } from './forms/partner/CtlPartnerForm';
import { CtlNewUserForm } from './forms/newuser/CtlNewUserForm';

import { CtlProjectGridComponent } from './grid/ctl-project-grid/ctl-project-grid.component';
import { CtlProjectListComponent } from './lists/ctl-project-list/ctl-project-list.component';

import { ProjectFilterPipe } from './directives/Filters/ctl.projectlist.filter';
import { UserFilterPipe } from './directives/Filters/ctl.userlist.filter';
import { GradeFilterPipe } from './directives/Filters/ctl.gradelist.filter';
import { ClassFilterPipe } from './directives/Filters/ctl.classlist.filter';
import { AssignFilterPipe } from './directives/Filters/ctl.assignteacher.filter';
import { CtlArrayObjectJoinPipe } from './directives/Filters/ctl.arrayobject.filter';
import { CtlSimpleModalComponent } from './ctl-simple-modal/ctl-simple-modal.component';

@NgModule({
  declarations: [
    ToolsComponent,
    ProjectFilterPipe,
    UserFilterPipe,
    GradeFilterPipe,
    ClassFilterPipe,
    AssignFilterPipe,
    CtlArrayObjectJoinPipe,
    CtlPagination,
    CtlWizardSteps,
    CtlLogoUpload,
    CtlNewMediaFileUploadComponent,
    CtlUserForm,
    CtlPartnerForm,
    CtlNewUserForm,
    CtlSchoolInfoDetail,
    ModalformComponent,
    CtlConfirmModalComponent,
    CtlSuccessModalComponent,
    CtlProjectGridComponent,
    CtlProjectListComponent,
    CtlSimpleModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    NguiAutoCompleteModule,
    NgPipesModule,
    NgxUploaderModule,
    TruncateModule,
    SelectDropDownModule,
    NgImageSliderModule,
    TranslateModule.forRoot()
  ],
  exports: [
    ToolsComponent,
    NgxPaginationModule,
    ProjectFilterPipe,
    UserFilterPipe,
    GradeFilterPipe,
    ClassFilterPipe,
    AssignFilterPipe,
    CtlArrayObjectJoinPipe,
    NgPipesModule,
    TruncateModule,
    SelectDropDownModule,
    CtlPagination,
    CtlLogoUpload,
    CtlNewMediaFileUploadComponent,
    NgxUploaderModule,
    CtlWizardSteps,
    CtlUserForm,
    CtlPartnerForm,
    CtlNewUserForm,
    CtlSchoolInfoDetail,
    ModalformComponent,
    CtlConfirmModalComponent,
    CtlSuccessModalComponent,
    CtlProjectGridComponent,
    CtlProjectListComponent,
    CtlSimpleModalComponent
  ]
})
export class ToolsModule { }
